import styled from "styled-components";

export const QuickTestSuccessContainerStyled = styled.div`
  padding: 20px 18px 104px 18px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .success_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    .status_wrap {
      margin-bottom: 20px;
    }
    .btn_wrap {
      margin: auto;
      max-width: 215px;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 40px 18px 104px 18px;
    .breadcrumb_layout {
      display: none;
    }
  }
`;
